module.exports = __webpack_public_path__ + "img/consultation_part8.57660a3c.png";